<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <form @submit.prevent="submit" class="card-body">
        <div>
          <div v-if="getPermission(1020).view" class="col-md-6">
            <label class="form-control-label required" for="companyTitle">شرکت</label>
            <treeselect v-model="companyId" :multiple="false" :placeholder="companyTitle ?? 'انتخاب کنید'"
              :disabled="(!createForm)" :showCount="true" noOptionsText="هنوز شرکتی تعریف نشده است"
              noResultsText="موردی یافت نشد" noChildrenText="این شرکت فاقد زیر مجموعه است" :options="companies" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="title">عنوان بخش</label>
            <input class="form-control" type="text" id="title" name="title" v-model.trim="title" />
          </div>
          <hr class="horizontal dark" />
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="isTicketingDefault" id="isTicketingDefault">
            <label class="form-check-label" for="isTicketingDefault">پیش فرض جهت ثبت تیکت</label>
          </div>
          <hr class="horizontal dark" />
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="hasConfidentialConversations" id="hasConfidentialConversations">
            <label class="form-check-label" for="hasConfidentialConversations">
              مکالمات بخش محرمانه هستند (در صورتی که تیکت در این بخش باشد، فقط کاربران زیرمجموعه این بخش قادر به مشاهده تیکت هستند)
            </label>
          </div>
          <hr class="horizontal dark" />
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="isShownToCustomers" id="isShownToCustomers">
            <label class="form-check-label" for="isShownToCustomers">نمایش به کاربران مشتری جهت ثبت تیکت</label>
          </div>
          <hr class="horizontal dark" />
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="isSpecial" id="isSpecial">
            <label class="form-check-label" for="isSpecial">بخش ویژه (فقط مشتریان مشخص شده می‌توانند به این بخش تیکت بزنند)</label>
          </div>
          <div class="py-2 container-fluid">
            <hr class="horizontal dark" />
            <div class="card h-100">
              <details>
                <summary>
                  <div class="card-header px-3 py-2 bg-gradient-success">
                    <h6 class="mb-0 text-capitalize text-white">مدیریت کاربران عضو</h6>
                  </div>
                </summary>
                <div class="card-body pt-2 px-2">
                  <member-users-manager :usersList="usersList" :memberUsers="users" :companyId="companyId" @addUser="addUser"
                    @removeUser="removeUser" />
                </div>
              </details>
            </div>
            <hr class="horizontal dark" />
            <roles-manager :currentRoles="roles" :companyId="companyId" @addRole="addRole" @removeRole="removeRole" />
          </div>
        </div>
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit">ثبت</button>
          <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/Company/Company-service.js';
import UserService from '@/services/User/User-service.js';
import MemberUsersManager from "@/views/components/MemberUsersManager.vue";
import RolesManager from "@/views/components/RolesManager.vue";
import { maxLength, helpers, required } from '@vuelidate/validators';
import Treeselect from '@cholakovdev/vue3-treeselect';
import { mapGetters } from "vuex";

export default {
  components: { Treeselect, MemberUsersManager, RolesManager },
  data() {
    return {
      v: this.$useVuelidate(),
      id: null,
      title: '',
      isTicketingDefault: false,
      isShownToCustomers: false,
      isSpecial: false,
      hasConfidentialConversations: false,
      companies: [],
      createForm: true,
      section: {},
      companyTitle: '',
      companyId: null,
      companyTitle: null,
      changed: false,
      users: [],
      roles: [],
      usersList: [],
    };
  },
  computed:{
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId(newId, oldId) {
      if (this.changed) {
        this.companyTitle = null;

        if (newId !== oldId) {
          this.users = [];
          this.roles = [];
          this.usersList = [];

          this.getListUsers();
        }
      }

      this.changed = true;
    },
  },
  methods: {
    submit() {
      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      let userIds = this.users.map(user => user.id);
      let roleIds = this.roles.map(role => role.id);

      // let newSection = {
      //   Title: this.title,
      //   CompanyId: this.companyId,
      //   IsTicketingDefault: this.isTicketingDefault,
      //   IsShownToCustomers: this.isShownToCustomers,
      //   IsSpecial: this.isSpecial,
      //   UserIds: userIds,
      //   RoleIds: roleIds,
      // };
      let vm = {
        Id: this.id ?? 0,
        Title: this.title,
        CompanyId: this.companyId,
        IsTicketingDefault: this.isTicketingDefault,
        IsShownToCustomers: this.isShownToCustomers,
        IsSpecial: this.isSpecial,
        HasConfidentialConversations: this.hasConfidentialConversations,
        UserIds: userIds,
        RoleIds: roleIds,
      };

      if (!this.createForm) {
        CompanyService.updateSection(vm).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.goBack(), 500);
          }
        }).catch(e => {
          console.log(e);
        });

        this.v.$reset();
      }
      else {
        CompanyService.addSection(vm).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);

            setTimeout(() => this.goBack(), 500);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    getSection() {
      CompanyService.getSection(this.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.title = result.data.title;
          this.isTicketingDefault = result.data.isTicketingDefault;
          this.isShownToCustomers = result.data.isShownToCustomers;
          this.isSpecial = result.data.isSpecial;
          this.hasConfidentialConversations = result.data.hasConfidentialConversations;
          this.section = result.data;
          this.companyId = result.data.companyId;
          this.companyTitle = result.data.companyTitle;
          this.users = result.data.users;
          this.roles = result.data.roles;
          
          this.getListUsers();
        } else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getListUsers() {
      if (this.companyId > 0) {
          UserService.getListByCompanyId(this.companyId).then(response => {
            let result = response.data;

            if (!result.success) {
              this.$toast.error(result.message);
            }
            else {
              this.usersList = result.data;
            }
          }).catch(e => {
            console.log(e);
          });
        }
    },
    addUser(user) {
      this.users.push(user);
    },
    removeUser(user) {
      let index = this.users.map(user => user.id).indexOf(user.id);

      this.users.splice(index, 1);
    },
    addRole(role) {
      this.roles.push(role);
    },
    removeRole(role) {
      let index = this.roles.map(role => role.id).indexOf(role.id);

      this.roles.splice(index, 1);
    },
    goBack() {
      if (this.companyId > 0) {
        this.$router.push('/sections/' + this.companyId);
      }
      else {
        this.$router.back();
      }
    }
  },
  created() {
    this.createForm = this.$route.meta.new;
    this.companies.push(this.$store.state.currentUserInfo.companies);

    if (!this.createForm) {
      this.id = this.$route.params.sectionId;
      this.getSection();
    }
    else {
      if (this.$route.params.companyId > 0) {
        this.companyId = this.$route.params.companyId;
        this.getListUsers();
      }
    }

  },
  validations() {
    let valObj = {
      companyId: {
        required: helpers.withMessage('لطفا "شرکت" مربوطه را انتخاب کنید', required),
      },
      title: {
        required: helpers.withMessage('لطفا "عنوان بخش" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "عنوان بخش"، 250 کاراکتر است', maxLength(250)),
      },
    };

    return valObj;
  }
}
</script>